/**
 * @param breakpoint
 */
export const isBelowViewportSize = (breakpoint) => {
  return window.innerWidth < breakpoint;
};

export const breakpoints = {
  lg: 896,
  xl: 1025,
};
